import { WatchlistConfig, WatchlistProfile } from '../models/watch-profile.model';

export function mapConfigToWatchlistProfile(config: WatchlistConfig): WatchlistProfile {
  return {
    WatchListId: config.wId,
    WatchListUID: '',
    McConnectionId: config.MCId,
    OsId: config.osId,
    Name: config.wName,
    CreatedAt: Date.now(),
    UpdatedAt: Date.now(),
  };
}
